<script>
    import { navigate } from "svelte-routing";
    import { produce } from "../stores";

    export let slug;
    export let newrecipe;
    let recipe = {
        name: "",
        description: "",
        ingredients: [],
        instructions: [],
        images: [],
        tags: [],
    };

    function addInstruction() {
        recipe.instructions = [...recipe.instructions, ""];
    }

    function removeInstruction(instructionId) {
        recipe.instructions.splice(instructionId, 1);
        recipe.instructions = [...recipe.instructions];
    }

    function addIngredientSection() {
        recipe.ingredients = [
            ...recipe.ingredients,
            {
                heading: "<new heading>",
                ingredients: [],
            },
        ];
    }

    function removeIngredientSection(sectionId) {
        recipe.ingredients.splice(sectionId, 1);
        recipe.ingredients = [...recipe.ingredients];
    }

    function addIngredient(sectionId) {
        recipe.ingredients[sectionId].ingredients = [
            ...recipe.ingredients[sectionId].ingredients,
            {
                produce: {},
                amount: 0,
                unit: "",
            },
        ];
    }

    function removeIngredient(sectionId, ingredientId) {
        recipe.ingredients[sectionId].ingredients.splice(ingredientId, 1);

        recipe.ingredients[sectionId].ingredients = [
            ...recipe.ingredients[sectionId].ingredients,
        ];
    }

    function assignProductsToIngredients() {
        recipe.ingredients.forEach((section) => {
            section.ingredients.forEach((ingredient) => {
                ingredient.produce = localProduce.find(
                    (p) => p.slug === ingredient.produce.slug
                );
            });
        });
    }

    let isSaving = false;
    async function save() {
        isSaving = true;
        await upload();

        let method;
        let route;
        if (newrecipe) {
            method = "POST";
            route = "/api/recipe";
        } else {
            method = "PUT";
            route = "/api/recipe/" + recipe.slug;
        }

        assignProductsToIngredients();
        let response = await fetch(route, {
            method,
            headers: {
                "content-type": "application/json",
            },
            body: JSON.stringify(recipe),
        });

        if (response.ok) {
            newrecipe = false;
            recipe = await response.json();
            navigate("/recipes/" + recipe.slug, { replace: false });
        } else {
            alert("Error");
        }

        isSaving = false;
    }

    let promise;
    if (newrecipe) {
        promise = Promise.resolve();
    } else {
        promise = (async () => {
            let result = await fetch("/api/recipe/" + slug);
            recipe = await result.json();
        })();
    }

    let localProduce = [];
    produce.subscribe((value) => (localProduce = value));

    let files = [];
    const upload = async () => {
        if (files.length === 0) {
            return;
        }

        const formData = new FormData();
        formData.append("file", files[0]);

        let result = await fetch("/api/image", {
            method: "POST",
            body: formData,
        });

        const urls = await result.json();

        recipe.images = recipe.images.concat(urls.urls);
        files = [];
    };

    const removeImage = (toBeDelted) => {
        recipe.images = recipe.images.filter((image) => image != toBeDelted);
    };
</script>

{#await promise then}
    <h1>{recipe.name}</h1>
    <div>
        <div class="with-sidebar">
            <label class="sidebar" for="name">Name</label>
            <input
                class="not-sidebar"
                id="name"
                type="text"
                bind:value={recipe.name}
            />
        </div>
        <div class="with-sidebar">
            <label class="sidebar" for="description">Description</label>
            <textarea
                class="not-sidebar"
                bind:value={recipe.description}
                id="description"
            />
        </div>
        {#if !newrecipe}
            <div class="with-sidebar">
                <label class="sidebar" for="fileUpload">Upload an image:</label>
                <div class="not-sidebar">
                    <input id="fileUpload" type="file" bind:files />
                    <div class="cluster">
                        {#each recipe.images as image}
                            <div class="stack">
                                <button on:click={() => removeImage(image)}
                                    >-</button
                                >
                                <img
                                    src="/api/image/{image}"
                                    height="32"
                                    alt="Image with id {image}"
                                />
                            </div>
                        {/each}
                    </div>
                </div>
            </div>
        {/if}
    </div>

    <div class="stack">
        {#if recipe.instructions}
            <h2>Instructions</h2>
            {#each recipe.instructions as instruction, instructionId}
                <div class="with-sidebar">
                    <label class="sidebar" for="instruction_{instructionId}"
                        >Details of step {instructionId + 1}</label
                    >
                    <div class="not-sidebar">
                        <div class="stack">
                            <textarea
                                bind:value={instruction}
                                style="width: 100%"
                            />
                            <button
                                on:click={() =>
                                    removeInstruction(instructionId)}
                                >Remove</button
                            >
                        </div>
                    </div>
                </div>
            {/each}
            <button on:click={addInstruction}>+ instruction</button>
        {/if}
    </div>

    <div class="stack">
        {#if recipe.ingredients}
            <h2>Ingredients</h2>
            {#each recipe.ingredients as ingredientSection, sectionId}
                <div class="with-sidebar">
                    <label class="sidebar" for="ingredient-section-{sectionId}">
                        Section {sectionId}
                    </label>
                    <div class="not-sidebar">
                        <div class="stack">
                            <div>
                                <input
                                    id="ingredient-section-{sectionId}"
                                    type="text"
                                    bind:value={ingredientSection.heading}
                                />
                                <button
                                    on:click={() =>
                                        removeIngredientSection(sectionId)}
                                    >- Remove section</button
                                >
                            </div>
                            {#each ingredientSection.ingredients as ingredient, ingredientId}
                                <div>
                                    <button
                                        on:click={() =>
                                            removeIngredient(
                                                sectionId,
                                                ingredientId
                                            )}>-</button
                                    >
                                    <input
                                        type="number"
                                        size="3"
                                        bind:value={ingredient.amount}
                                    />

                                    <select
                                        bind:value={ingredient.produce.slug}
                                    >
                                        {#each localProduce as singleProduce}
                                            <option value={singleProduce.slug}
                                                >{singleProduce.name} ({singleProduce.baseAmount}{singleProduce.baseUnit})</option
                                            >
                                        {/each}
                                    </select>
                                </div>
                            {/each}
                            <button on:click={() => addIngredient(sectionId)}
                                >+ ingredient</button
                            >
                        </div>
                    </div>
                </div>
            {/each}
            <button on:click={addIngredientSection}>+ section</button>
        {/if}
    </div>
    <div>
        <button on:click={save} class="fill" disabled={isSaving}>Save</button>
    </div>
{/await}
